'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.page-landing-rh').length <= 0 ) {
        return
    }

    const carousel = new Swiper('.page-landing-rh__testimonials', {
        autoplay: true,
        slidesPerView: 1,
        grabCursor: true,
        parallax: true,
        speed: 500,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
    })

    $('.page-landing-rh__testimonials').on('mouseenter', function() {
        carousel.autoplay.stop()
    })

    $('.page-landing-rh__testimonials').on('mouseleave', function() {
        carousel.autoplay.start()
    })
}
